<div [formGroup]="form" class="mb-3">
  <label class="mb-2" [for]="id" [attr.data-test-id]="labelDataTestId"> {{ inputLabel | translate }} * </label>
  <div class="input-group">
    <input
      class="form-control"
      [ngClass]="{
        'is-invalid': invalid,
        'is-valid': showValidMark && formValid
      }"
      [type]="showPassword ? 'text' : 'password'"
      [formControlName]="controlName"
      [id]="id"
      (blur)="onBlur()"
      [attr.data-test-id]="dataTestId"
      placeholder="{{ placeholder || 'LOGIN_FORM_PASSWORD_INPUT_PLACEHOLDER' | translate }}"
    />
    <div class="input-group-text">
      <i
        class="fa"
        [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"
        (click)="togglePasswordFieldType()"
        [attr.data-test-id]="iconDataTestId"
      ></i>
    </div>
    <small class="invalid-feedback" [attr.data-test-id]="errorTexting.dataTestId">
      {{ errorTexting.text | translate }}
    </small>
    <small *ngIf="showValidMark && validTexting" class="valid-feedback" [attr.data-test-id]="validTexting.dataTestId">
      {{ validTexting.text | translate }}
    </small>
    <small
      *ngIf="instructionTexting"
      class="form-text col-12"
      [ngClass]="invalid ? 'invalid-feedback invalid-password' : 'text-muted'"
      [hidden]="formValid"
      [attr.data-test-id]="instructionTexting.dataTestId"
    >
      {{ instructionTexting.text | translate }}
    </small>
  </div>
</div>
